"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventTransitionToEventState = exports.validEventTransitions = exports.EventTransition = void 0;
const _1 = require(".");
var EventTransition;
(function (EventTransition) {
    EventTransition["StartProcessing"] = "Start processing";
    EventTransition["PutInReview"] = "Put in review";
    EventTransition["MarkAsComplete"] = "Mark as Complete";
    EventTransition["UploadedParticipants"] = "Upload Participants";
})(EventTransition = exports.EventTransition || (exports.EventTransition = {}));
exports.validEventTransitions = {
    [_1.EventState.WaitingForAssets]: [],
    [_1.EventState.ReadyToClip]: [EventTransition.StartProcessing],
    [_1.EventState.ClippingInProgress]: [EventTransition.PutInReview],
    [_1.EventState.ReviewNeeded]: [EventTransition.MarkAsComplete],
    [_1.EventState.Complete]: [],
};
exports.eventTransitionToEventState = {
    [EventTransition.StartProcessing]: _1.EventState.ClippingInProgress,
    [EventTransition.PutInReview]: _1.EventState.ReviewNeeded,
    [EventTransition.MarkAsComplete]: _1.EventState.Complete,
};
//# sourceMappingURL=event-transition.js.map